<template>
    <div class="flex flex-col items-start">
        <div class="flex flex-row items-center justify-between gap-2">
            <span v-if="product.brand" class="sim-font-bold">
                {{ product.brand?.name }}
            </span>

            <!-- TODO - product rating -->
        </div>

        <h1 class="sim-h1 mb-5">
            {{ product.getName(selectedVariation) }}
        </h1>

        <p v-if="product.shortDescription"
           class="sim-wysiwyg-text mb-5 hidden lg:block"
        >
            <span class="inline" v-html="product.shortDescription" />&nbsp;

            <NuxtLink class="text-simplo inline-flex items-center gap-1 no-underline hover:underline"
                      :to="`#${productDescriptionId}`"
            >
                {{ $t('product.more_information') }}

                <IconChevron size="xs" :rotate="-90" />
            </NuxtLink>
        </p>

        <hr>
    </div>
</template>

<script lang="ts" setup>

const {
    product,
    selectedVariation,
    productDescriptionId,
} = defineProps<{
    product: InstanceType<typeof ProductModel>
    selectedVariation?: InstanceType<typeof ProductVariationModel> | null
    productDescriptionId: string
}>()

</script>

<style lang="scss">

</style>
